import type { NaviStatus } from '@/api/warehouse'

/** Lager-Navi Farbsprache: belegt = Stahl (die Palette steht da), frei = offenes Fach mit
 *  gestrichelter Kante, wartet = Bernstein schraffiert (Erstaufnahme offen). Packplatz ist
 *  kein Status: blaue Kante links, wie ein Klebeband am Regalholm. */
export const STAHL = '#33414f'
export const STAHL_HELL = '#5b6b7b'
export const BERNSTEIN = '#f59e0b'

export const STATUS_TEXT: Record<NaviStatus, string> = { frei: 'frei', belegt: 'belegt', wartet: 'wartet auf Aufnahme', notiz: 'Notiz' }

export const STATUS_KLASSE: Record<NaviStatus, string> = {
  belegt: 'bg-[#33414f] border-[#33414f] text-white',
  frei: 'bg-white border-dashed border-[#b8c2cc] text-ink-2',
  wartet: 'bg-warn-soft border-[#f59e0b] text-[#7a4b00]',
  notiz: 'bg-slate-100 border-slate-400 text-ink',
}

export const SCHRAFFUR = 'repeating-linear-gradient(135deg, transparent 0 6px, rgba(245,158,11,.28) 6px 8px)'
export const NOTIZ_STREIFEN = 'repeating-linear-gradient(135deg, transparent 0 6px, rgba(51,65,79,.12) 6px 8px)'

export const LAGER_2_REIHEN = 'R22–R32'
